import axios from 'axios';

interface FindAlmanacAgentUserSubscriptionResponse {
  agent: string;
  coop: string;
}

const findAlmanacAgentUserSubscription = async () => {
  const config = {
    url: `/almanac/agent_subscription`,
    method: 'get' as const,
  };

  const { data } =
    await axios.request<FindAlmanacAgentUserSubscriptionResponse>(config);
  return data;
};

export default findAlmanacAgentUserSubscription;
